import { Component, inject } from '@angular/core';
import { DialogRef } from '../modal/dialog-ref';
import { DIALOG_DATA } from '../modal/dialog-tokens';
import { CoreLibModalComponent } from '../modal/modal.component';

@Component({
  selector: 'mh-core-lib-session-expired-modal',
  standalone: false,
  templateUrl: './session-expired-modal.component.html',
})
export class CoreLibSessionExpiredModalComponent extends CoreLibModalComponent {
  constructor() {
    super(inject(DialogRef), inject(DIALOG_DATA));
  }
}
